import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Input, Button, Typography, Alert, Divider, Grid } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, userSelector, clearState } from "../../features/authSlice";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const PortalLogin = () => {
  const navigate  = useNavigate();
  const dispatch  = useDispatch();
  const screens   = useBreakpoint();
  const isMobile  = !screens.md;
  const { isFetching, isSuccess, isError, errorMessage } = useSelector(userSelector);
  const [form] = Form.useForm();

  useEffect(() => { dispatch(clearState()); }, [dispatch]);

  useEffect(() => {
    if (isSuccess) navigate("/portal/search-index");
  }, [isSuccess, navigate]);

  const onFinish = (values) => { dispatch(loginUser(values)); };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: isMobile ? "column" : "row" }}>

      {/* Panel decorativo — oculto en mobile */}
      {!isMobile && (
        <div style={{
          flex: 1,
          background: "linear-gradient(135deg, #1d3557 0%, #457b9d 100%)",
          display: "flex", flexDirection: "column",
          justifyContent: "center", alignItems: "center",
          padding: "2rem", color: "white", textAlign: "center",
        }}>
          <img
            src="/logo.png" alt="Notaría"
            style={{ height: 80, objectFit: "contain", filter: "brightness(0) invert(1)", marginBottom: 24 }}
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <Title level={2} style={{ color: "white", marginBottom: 8 }}>Portal de Clientes</Title>
          <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: 16, lineHeight: 1.7 }}>
            Notaría Juan Carlos Cabezas Cepeda<br />Puerto Montt, Chile
          </Text>
          <Divider style={{ borderColor: "rgba(255,255,255,0.2)", margin: "24px 0" }} />
          <Text style={{ color: "rgba(255,255,255,0.7)", fontSize: 14 }}>
            Accede a tus documentos notariales y mantén tu información actualizada.
          </Text>
        </div>
      )}

      {/* Panel del formulario */}
      <div style={{
        flex: 1,
        background: isMobile ? "#f0f2f5" : "white",
        display: "flex", flexDirection: "column",
        justifyContent: isMobile ? "flex-start" : "center",
        alignItems: "center",
        padding: isMobile ? "32px 20px" : "2rem",
        minHeight: isMobile ? "100vh" : "auto",
      }}>

        {/* Logo en mobile */}
        {isMobile && (
          <div style={{ textAlign: "center", marginBottom: 32 }}>
            <div style={{
              width: 72, height: 72, borderRadius: "50%",
              background: "linear-gradient(135deg, #1d3557, #457b9d)",
              display: "flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 16px",
            }}>
              <img
                src="/logo.png" alt="Notaría"
                style={{ height: 44, objectFit: "contain", filter: "brightness(0) invert(1)" }}
                onError={(e) => { e.target.style.display = "none"; }}
              />
            </div>
            <Title level={4} style={{ color: "#1d3557", marginBottom: 4 }}>Portal de Clientes</Title>
            <Text type="secondary" style={{ fontSize: 13 }}>Notaría Juan Carlos Cabezas Cepeda</Text>
          </div>
        )}

        <div style={{
          width: "100%", maxWidth: 380,
          background: "white", borderRadius: isMobile ? 16 : 0,
          padding: isMobile ? "28px 24px" : 0,
          boxShadow: isMobile ? "0 4px 24px rgba(0,0,0,0.08)" : "none",
        }}>
          <Title level={3} style={{ color: "#1d3557", marginBottom: 8 }}>Iniciar sesión</Title>
          <Text type="secondary" style={{ display: "block", marginBottom: 24 }}>
            ¿No tienes cuenta?{" "}
            <Link to="/portal/register" style={{ color: "#457b9d", fontWeight: 600 }}>
              Regístrate aquí
            </Link>
          </Text>

          {isError && (
            <Alert
              message={errorMessage || "Credenciales incorrectas"}
              type="error" showIcon style={{ marginBottom: 16 }}
            />
          )}

          <Form form={form} layout="vertical" onFinish={onFinish} size="large">
            <Form.Item
              label="Email" name="email"
              rules={[
                { required: true, message: "Ingresa tu email" },
                { type: "email", message: "Email inválido" },
              ]}
            >
              <Input placeholder="tu@email.com" autoComplete="email" />
            </Form.Item>

            <Form.Item
              label="Contraseña" name="password"
              rules={[{ required: true, message: "Ingresa tu contraseña" }]}
            >
              <Input.Password placeholder="••••••••" autoComplete="current-password" />
            </Form.Item>

            <div style={{ textAlign: "right", marginBottom: 16 }}>
              <Link to="/portal/forgot-password" style={{ color: "#457b9d", fontSize: 13 }}>
                ¿Olvidaste tu contraseña?
              </Link>
            </div>

            <Form.Item>
              <Button
                type="primary" htmlType="submit" block loading={isFetching}
                style={{ height: 46, background: "#1d3557", borderColor: "#1d3557", borderRadius: 8 }}
              >
                Ingresar
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default PortalLogin;
